import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { MaskField, TextField } from '~/elements';
import getErrorMsg from '~/helpers/errorMessages';
import Select from '../../Select';
import countryStates from '~/config/countryStates';

export default function FormContent({
  formControl,
  disableFields,
  address,
  watch,
}) {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={12} md={6}>
        {address && (
          <input type="hidden" name="address.id" ref={formControl.register()} />
        )}
        <MaskField
          ariaLabel="cep"
          fullWidth
          label="CEP *"
          name="address.zipcode"
          type="tel"
          mask="99999-999"
          formControl={formControl}
          rules={{
            required: true,
            minLength: 9,
          }}
          inputProps={{
            autoComplete: 'disabled',
            autoFocus: !address?.zipcode,
          }}
          error={!!formControl.errors?.address?.zipcode}
          caption={getErrorMsg(formControl?.errors?.address || {}, 'zipcode')}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <TextField
          ariaLabel="endereço"
          fullWidth
          label="Endereço *"
          name="address.street"
          formControl={formControl}
          disabled={disableFields?.includes('address.street')}
          rules={{
            required: true,
          }}
          error={!!formControl?.errors?.address?.street}
          caption={getErrorMsg(formControl?.errors?.address || {}, 'street')}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <Grid container spacing={3}>
          <Grid item xs={5}>
            <TextField
              ariaLabel="número"
              fullWidth
              label="Número"
              name="address.number"
              formControl={formControl}
              disabled={disableFields?.includes('address.number')}
              error={!!formControl?.errors?.address?.number}
              caption={getErrorMsg(
                formControl?.errors?.address || {},
                'number',
              )}
            />
          </Grid>
          <Grid item xs={7}>
            <TextField
              ariaLabel="complemento"
              fullWidth
              label="Complemento"
              name="address.complement"
              formControl={formControl}
              disabled={disableFields?.includes('address.complement')}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <TextField
          ariaLabel="bairro"
          fullWidth
          label="Bairro *"
          name="address.neighborhood"
          formControl={formControl}
          disabled={disableFields?.includes('address.neighborhood')}
          rules={{
            required: true,
          }}
          error={!!formControl?.errors?.address?.neighborhood}
          caption={getErrorMsg(
            formControl?.errors?.address || {},
            'neighborhood',
          )}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <Grid container spacing={3}>
          <Grid item xs={5}>
            <Select
              label="Estado *"
              name="address.state"
              formControl={formControl}
              rules={{
                required: true,
              }}
              error={!!formControl?.errors?.address?.state}
              caption={getErrorMsg(formControl?.errors?.address || {}, 'state')}
              value={watch('address.state') || ''}
              options={countryStates}
              disabled={disableFields?.includes('address.state')}
            />
          </Grid>
          <Grid item xs={7}>
            <TextField
              ariaLabel="cidade"
              label="Cidade *"
              name="address.city"
              formControl={formControl}
              disabled={disableFields?.includes('address.city')}
              rules={{
                required: true,
              }}
              error={!!formControl?.errors?.address?.city}
              caption={getErrorMsg(formControl?.errors?.address || {}, 'city')}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

FormContent.propTypes = {
  formControl: PropTypes.object.isRequired,
  address: PropTypes.object,
  disableFields: PropTypes.array,
  watch: PropTypes.func,
};
